import axios from "axios";
import url from "../config/urlServiceConfig";

const perspectiveAPI = {
  getAll: () => axios.get(url.perspective),
  getById: (id) => axios.get(`${url.perspective}/${id}`),
  create: (body) => axios.post(url.perspective, body),
  update: (body) => axios.put(url.perspective, body),
  delete: (id) => axios.delete(`${url.perspective}/${id}`),
  getObjectivesWithKPIs: (id, params) =>
    axios.get(`${url.perspective}/StrategicObjective/KPIs/${id}`, { params }),
};

export default perspectiveAPI;
